// extracted by mini-css-extract-plugin
export var buyNowButton = "product-card-module--buy-now-button--mdacZ";
export var cardTitle = "product-card-module--card-title--wHGV0";
export var empty = "product-card-module--empty--wSJSR";
export var gridTile = "product-card-module--grid-tile--oK-T4";
export var image = "product-card-module--image--drrgV";
export var imageDiv = "product-card-module--image-div--nHEHX";